import { render, staticRenderFns } from "./docking-auth.vue?vue&type=template&id=65fe0b91&scoped=true"
import script from "./docking-auth.vue?vue&type=script&lang=js"
export * from "./docking-auth.vue?vue&type=script&lang=js"
import style0 from "./docking-auth.vue?vue&type=style&index=0&id=65fe0b91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe0b91",
  null
  
)

export default component.exports